// extracted by mini-css-extract-plugin
module.exports = {"componentsMenu":"ComponentsMenu_componentsMenu__3hIxA","newTag":"ComponentsMenu_newTag__3dQcV"};